import { Divider, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';
import ChildCard from '../../../shared/ChildCard';
import { useDispatch } from 'react-redux';
import BackButton from '../../../shared/button/BackButton';
import { useParams } from 'react-router';
import { useMsal } from '@azure/msal-react';
import { fetchBackOfficeConfirmationNumber, fetchBackOfficeReservationById } from 'src/store/reservations/slices/ReservationsManagerSlice';
import { setReservationOverviewVisibility } from 'src/store/reservations/slices/hotels/HotelDetailSlice';
import ErrorView from 'src/components/errors/ErrorView';
import ViewReservationsInfo from './ViewReservationsInfo';
import ViewSummarySection from './ViewSummarySection';
import ViewReservationsOverviewSkeleton from './ViewReservationsOverviewSkeleton';
import { providerHelpers } from 'src/utils/providerConfig';

const ViewReservationsOverview = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const { instance, accounts } = useMsal();
    const [error, setError] = useState(null);    

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await dispatch(fetchBackOfficeReservationById(instance, accounts, id));
                const IsRequiredGetConfirmationNumber = providerHelpers.getConfirmationNumber(result.Provider);
                if (IsRequiredGetConfirmationNumber) {
                    await dispatch(fetchBackOfficeConfirmationNumber(instance, accounts, id, result.Provider));
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id, dispatch, instance, accounts]);

    const handleClick = () => {
        dispatch(setReservationOverviewVisibility(false));
    };

    const handleClose = () => {
        setError(null);
    };

    return (
        <ChildCard sx={{ p: 3, borderRadius: 2, boxShadow: 1 }}>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                    <ViewReservationsOverviewSkeleton />
                </Box>
            ) : (
                <>
                    {(error) && (
                        <ErrorView
                            error={error}
                            onClose={handleClose}
                        />
                    )}
                    <ViewReservationsInfo setError={setError} />
                    <Divider mb={3} />
                    <ViewSummarySection setError={setError} />
                    <Grid size={12} mt={5}>
                        <BackButton onClick={handleClick} to={`/reservations/view`} />
                    </Grid>
                </>
            )}
        </ChildCard>
    );
};

export default ViewReservationsOverview;
